import React from 'react';
import { getTranscriptSegments } from '../utils/formatTranscriptDisplay';

const SPEAKER_COLORS = [
    'text-blue-800 bg-blue-50 border-blue-100',
    'text-violet-800 bg-violet-50 border-violet-100',
    'text-emerald-800 bg-emerald-50 border-emerald-100',
    'text-amber-800 bg-amber-50 border-amber-100',
    'text-rose-800 bg-rose-50 border-rose-100'
];

const TranscriptTurns = ({ recording }) => {
    const segments = getTranscriptSegments(recording);
    const speakerIndex = {};
    let colorIdx = 0;

    const colorFor = (speaker) => {
        if (!speakerIndex[speaker]) {
            speakerIndex[speaker] = colorIdx % SPEAKER_COLORS.length;
            colorIdx += 1;
        }
        return SPEAKER_COLORS[speakerIndex[speaker]];
    };

    if (segments.length === 0) {
        return (
            <p className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                {recording?.transcript || 'No transcript available.'}
            </p>
        );
    }

    return (
        <div className="space-y-4">
            {segments.map((seg, index) => (
                <div
                    key={`${seg.speaker}-${index}`}
                    className={`rounded-xl border px-4 py-3 ${colorFor(seg.speaker)}`}
                >
                    <p className="text-sm font-semibold mb-1">{seg.speaker}</p>
                    <p className="text-gray-800 leading-relaxed whitespace-pre-wrap">{seg.text}</p>
                </div>
            ))}
        </div>
    );
};

export default TranscriptTurns;
